import { StringPrimitiveParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (initialValue?: string): StringPrimitiveParameterValue => ({
  type: PARAMETER_VALUE_TYPE.STRING_PRIMITIVE,
  value: initialValue || null,
});
